export default __webpack_public_path__ + "static/media/extended_logo.b89072da.png";